@let loading = input.loading | parse: context | async;
@let icon = input.icon | parse: context | async;
@let disabled = input.disabled | parse: context | async;
@let text = input.text | parse: context | async;
@let diameter = 14;

@switch (input.style) {
  @case ('basic') {
    <button
      mat-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
      @if (input.menuWidgets) {
        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></span>
      }
    </button>
  }
  @case ('raised') {
    <button
      mat-raised-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
      @if (input.menuWidgets) {
        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></span>
      }
    </button>
  }
  @case ('stroked') {
    <button
      mat-stroked-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
      @if (input.menuWidgets) {
        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></span>
      }
    </button>
  }
  @case ('flat') {
    <button
      mat-flat-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
      @if (input.menuWidgets) {
        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></span>
      }
    </button>
  }
  @case ('icon') {
    <button
      mat-icon-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
      @if (input.menuWidgets) {
        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></span>
      }
    </button>
  }
  @case ('fab') {
    <button
      mat-fab
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
      @if (input.menuWidgets) {
        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></span>
      }
    </button>
  }
  @case ('mini-fab') {
    <button
      mat-mini-fab
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
      @if (input.menuWidgets) {
        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></span>
      }
    </button>
  }
}

<mat-menu #menu="matMenu">
  @for (widget of input.menuWidgets; track widget) {
    <ng-container [dynamicWidget]="widget" [context]="context" />
  }
</mat-menu>
